import { InfoIcon } from "@chakra-ui/icons";
import { FormHelperText, HStack, Input, Text, Tooltip, Wrap } from "@chakra-ui/react";
import FormInputWraper from "../../Components/FormInputWrapper";
import type { FormStepProps } from "../../interfaces";
import { INPUT_SIZE, INPUT_VARIANT } from "../../RegisterPage";
import { useTranslations } from "next-intl";
import useTranslationConstants from "lib/utils/constants";

const HeightWeightAndRestHeartRate = ({ FormController }: FormStepProps) => {
  const { MEASURE_REST_HR_MESSAGE } = useTranslationConstants();
  const t = useTranslations("pages.register");
  return (
    <Wrap direction={"row"} w="full" spacing={5}>
      <FormInputWraper
        isRequired
        flex={1}
        label={t("height")}
        field_name="height"
        color="brandOrange.500"
        FormController={FormController}
      >
        <Input
          variant={INPUT_VARIANT}
          size={INPUT_SIZE}
          type="number"
          {...FormController.register("height", {
            required: t("heightMessage"),
            min: {
              value: 0,
              message: t("invalidHeight")
            }
          })}
        />
      </FormInputWraper>
      <FormInputWraper
        flex={1}
        isRequired
        label={t("weight")}
        field_name="weight"
        color="brandOrange.500"
        FormController={FormController}
      >
        <Input
          variant={INPUT_VARIANT}
          size={INPUT_SIZE}
          type="number"
          {...FormController.register("weight", {
            required: t("weightMessage"),
            min: {
              value: 0,
              message: t("invalidWeight")
            }
          })}
        />
      </FormInputWraper>
      <FormInputWraper
        flex={1}
        label={t("restHeartRate")}
        field_name="rest_heart_rate"
        color="brandOrange.500"
        FormController={FormController}
        isRequired
      >
        <Input
          variant={INPUT_VARIANT}
          size={INPUT_SIZE}
          type="number"
          defaultValue={"70"}
          {...FormController.register("rest_heart_rate", {
            required: t("restHeartRateMessage"),
            min: {
              value: 0,
              message: t("invalidRestHeartRate")
            }
          })}
        />
        <Tooltip label={MEASURE_REST_HR_MESSAGE}>
          <HStack pt={2}>
            <InfoIcon fontSize={"sm"} color="gray.600" />
            <Text fontSize={"sm"}>{t("howToMesure")}</Text>
          </HStack>
        </Tooltip>
      </FormInputWraper>
      <FormInputWraper
        flex={1}
        label={t("maxHeartRate")}
        field_name="max_heart_rate"
        color="brandOrange.500"
        FormController={FormController}
        isRequired
      >
        <Input
          variant={INPUT_VARIANT}
          size={INPUT_SIZE}
          type="number"
          disabled={!FormController.watch("bday_year") || FormController.watch("bday_year") < 1930 || FormController.watch("bday_year") > new Date().getFullYear()}
          {...FormController.register("max_heart_rate", {
            required: t("maxHeartRateMessage"),
            min: {
              value: 0,
              message: t("invalidMaxHeartRate")
            }
          })}
        />
        <FormHelperText>
          {t("autoFillDateOfBirth")}
        </FormHelperText>
      </FormInputWraper>
    </Wrap>
  );
};

export default HeightWeightAndRestHeartRate;
